<template>
  <v-dialog v-if="note.files.length > 0" max-width="1000">
    <template #activator="{ on }">
      <button-tooltip
        :tooltip-text="$t('fresh-vue-notes.actions.show-attachments')"
        icon="$freshvuenotes-show-attachments"
        :badge-content="note.files.length"
        v-on="on"
      />
    </template>

    <card-base :error="error" :loading="loading" :disabled="loading">
      <file-gallery
        :files="note.files"
        disable-sort
        deletable
        do-not-remove-files-from-internal-cache-on-delete
        @delete="onDelete"
      />
    </card-base>
  </v-dialog>
</template>

<script>
import gql from 'graphql-tag'

import { FILE as FRAGMENT_FILE } from '@freshsolutions/fresh-vue-files/src/graphql/fragments.js'

import CardBase from '@freshsolutions/fresh-vue-cards/src/components/CardBase.vue' // Just import the component we need. Otherwise it won't work.
import { ButtonTooltip } from '@freshsolutions/fresh-vue'
import { FileGallery } from '@freshsolutions/fresh-vue-files'

export default {
  name: 'NotesListNote',

  components: {
    CardBase,
    ButtonTooltip,
    FileGallery
  },

  props: {
    note: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      error: false
    }
  },

  methods: {
    onDelete(file) {
      this.loading = true
      this.error = false

      this.$apollo
        .mutate({
          mutation: gql`
            mutation updateNote($id: ID!, $input: UpdateNoteInput!) {
              updateNote(id: $id, input: $input) {
                id

                files {
                  ...File
                  url_show
                  url_download
                }
              }
            }
            ${FRAGMENT_FILE}
          `,
          variables: {
            id: this.note.id,
            input: {
              files: {
                delete: [file.id]
              }
            }
          }
        })
        .then(() => {
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.error = true
        })
    }
  }
}
</script>
